module.exports = __webpack_public_path__ + "static/media/youre-on-fire-bomb.9287d356.svg";